import AsyncComponent from '../../component/asynccomponent/AsyncComponent';
import { RolesEnum, CompanyTypesEnum } from '../../utils/Enums';

const user = AsyncComponent(() =>
  import('../../../pages/user/UserProfile')
)

export default [
  {
    path: '/user/profile',
    component: user,
    isAuthenticated: true,
    roles: [RolesEnum.BackOffice, RolesEnum.Manager, RolesEnum.Operator],
    companyTypes: [CompanyTypesEnum.Tranpo, CompanyTypesEnum.Hired, CompanyTypesEnum.Contractor, CompanyTypesEnum.Benefited]
  }
]



// WEBPACK FOOTER //
// ./src/shared/infra/routes/UserRoutes.js